import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const HeaderStyled = styled(Stack)(() => ({
  '.header-title': {
    overflowWrap: 'anywhere',
    lineHeight: '160%',
  },
}));
